<template>
  <div class="home">
  </div>
</template>

<script>
import jwt_decode from "jwt-decode"
import { Component, Vue } from 'vue-property-decorator';
import {authInstance} from '@/services/AuthService.js';
// import axios from 'axios';

const auth = authInstance();

@Component
export default class Login extends Vue {
  currentUser = '';
  accessTokenExpired = false;
  isLoggedIn = false;

  mounted() {
    auth.getUser().then((user) => {
      if (user) {
        this.currentUser = user.profile.sub;
        this.accessTokenExpired = user.expired;
      }

      this.isLoggedIn = (user !== undefined && user !== null && !user.expired);

      if (!this.isLoggedIn) {
        this.$store.commit('userStates/updateToken', null)
        this.$store.commit('userStates/updateRefreshToken', null)
        this.$store.commit('userStates/updateProfileId', null);
        this.$store.commit('userStates/updateUserTenant', null)
        this.$store.commit('userStates/updateLoggedIn', false);
        this.$store.commit('userStates/updateUser', {})
        auth.login();
      } else {
        auth.getAccessToken().then((data) => {
          if (!data?.access_token) {
            alert('no access token, logout')
            this.$store.commit('userStates/updateToken', null)
            this.$store.commit('userStates/updateRefreshToken', null);
            this.$store.commit('userStates/updateProfileId', null);
            this.$store.commit('userStates/updateUserTenant', null)
            this.$store.commit('userStates/updateLoggedIn', false);
            this.$store.commit('userStates/updateUser', {})
            auth.logout()
          } else {
            this.$store.commit('userStates/updateToken', data.access_token);
            this.$store.commit('userStates/updateRefreshToken', data.refresh_token);
            this.$store.commit('userStates/updateLoggedIn', true);

            // Redirect advisor to dashboard, rest to the participants
            const { role_id, role_name } = jwt_decode(data.access_token)
            if (`${role_id}` === `5` || role_name === 'Advisor') {
              this.$router.push('/dashboard');
            } else if (`${role_id}` === `4` || role_name === 'Administrator') {
              this.$router.push('/advisors-dashboard');
            } else {
              this.$router.push('/participants');
            }
          }
        })
      }
    });
  }
};
</script>
